export enum ShiftMoveActionTypes {
    Add,        // Shift gets added when the shift is dropped
    Replace     // Shift will replace the existing shift in the drop zone
}